import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { format, parseISO } from 'date-fns';
import { CountryVm } from 'src/app/api';
import { CombinedStore } from 'src/app/core/combined.store';
import { Context } from '../models/interface/concretes/context.interface';
import { HmBrand, isPartner } from '../utils/brand-utils';
import { ContextsService } from './../../api/api/contexts.service';
import { civiliteObject, Civility } from './../models/model/concretes/shared/civility.model';
import { CANAL_VENTE_C } from '../constants/context.constants';
import { ERROR_EMAIL_PATH } from '../constants/route.constants';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContextGuard implements CanActivate {
  private store = inject(CombinedStore);

  civilities: Civility[] = civiliteObject;
  constructor(
    private router: Router,
    private contextService: ContextsService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const context = route.data['context'] as Context;
    const contextId = route.params['id'];
    console.log('ContextResolver: resolve', contextId);
    this.contextService
      .apiContextsIdGet(contextId)
      .pipe()
      .subscribe(context => {
        if (context) {
          sessionStorage.clear();
          this.store.reset();
          this.store.updateContext(context);
          if (this.store.context().souscripteur?.email) {
            this.updateSubscriberWithContext();
          }
          else if (this.store.context().canalVente === CANAL_VENTE_C && isPartner(environment))
          {
            // In partner mode, if no email in context, redirect to error with specific message
            this.router.navigate(['/' + ERROR_EMAIL_PATH]);
            return;
          }
          // Redirection
          this.router.navigate(['/start', context.token]);
        }
        // Empêche l'accès au composant cible après redirection
        return false;
      });

    return false;
  }

  private updateSubscriberWithContext() {
    const dateString = this.store.context().souscripteur?.dateNaissance ?? '';
    const date = dateString != '' ? parseISO(dateString) : '';
    const formattedDate = dateString != '' ? format(date, 'dd/MM/yyyy') : '';
    let phone = '';

    if (
      this.store.context().souscripteur?.telephone &&
      this.store.context().codeVendeur !== HmBrand
    ) {
      phone = this.store.context().souscripteur?.telephone ?? '';
    }
    this.store.updateSubscriber({
      email: this.store.context().souscripteur?.email ?? '',
      civility:
        this.civilities.find(m => m.id == this.store.context().souscripteur?.civilite) ?? null,
      lastname: this.store.context().souscripteur?.nom ?? '',
      firstname: this.store.context().souscripteur?.prenom ?? '',
      birth_date: formattedDate,
      birth_postal_code: null,
      birth_city: this.store.context().souscripteur?.villeNaissance ?? '',
      birth_country:
        this.mapToCountryVm(this.store.context().souscripteur?.paysNaissance ?? '') ?? null,
      nationality: null,
      phone_prefix: {
        indicator: null,
        phone: phone,
        phone_consent: false,
      },
      consent: {
        marketing_phone_consent: false,
        marketing_email_consent: false
      },
      is_client: false,
      from_context: true
    });
  }

  private mapToCountryVm(countryName: string | undefined): CountryVm | null {
    if (!countryName) {
      return null;
    }

    return {
      countryCode: countryName == 'France' ? 'FR' : null,
      countryNameFr: countryName
    };
  }
}
